import React from 'react';
import { useSelector } from 'react-redux';

import { Fire, Tools, Time } from '../../services'

import Switch from 'react-switch'
import Select from 'react-select';
import { Input } from 'reactstrap'
import { Headerbar, FormInput, Loader, Table, EditContainer, ImagesPicker, ListContainer, ConfirmButton } from '../Reusable'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

const ExpandedComponent: React.FC<any> = (props) => {
  const { data, refresh } = props
  const userRef = Fire.collection('users').doc(data.user.id)

  const onValidate = async (item: any, validate: boolean) => {
    const ref = Fire.collection('orders').doc(data.id)
    const tickets = data.tickets
    for (const ticket of tickets) {
      if (ticket.code == item.code) {
        ticket.validated = validate
        if (ticket.validated)
          ticket.validatedAt = new Date()
        else
          delete ticket.validatedAt
      }
    }
    try {
      const batch = Fire.batch()
      batch.update(ref, { tickets: tickets })
      batch.update(userRef, { lastTicketsUpdate: new Date() })
      await batch.commit()
      await refresh()
    } catch (err) {
      console.warn(err)
    }
  }

  const onRefund = async (item: any) => {
    const orderId = data.id
    const ticketCode = item.code
    try {
      const res = await Fire.cloud('refundTicket', { orderId: orderId, ticketCode: ticketCode })
      if (res.status === 'success')
        await refresh()
      else
        console.warn(res)
    } catch (err) {
      console.warn(err)
    }
  }

  return (
    <Table
      data={data.tickets.map((item) => ({
        ...item,
        code_col: item.code || '-',
        refunded_col: item.refunded ? 'Oui' : 'Non',
        validated_col: item.validated ? 'Oui' : 'Non',
        date_validated_col: item.validatedAt ? Fire.getDateFor(item.validatedAt) : new Date(),
        date_col: item.validatedAt ? Time.moment(Fire.getDateFor(item.validatedAt)).format('DD/MM/YYYY HH[h]mm') : '-'
      }))}
      columns={[
        { name: 'Code', string: 'code_col', sortable: true, accessor: 'code_col' },
        { name: 'Ticket', string: 'name', sortable: true, accessor: 'name' },
        { name: 'Remboursé', string: 'refunded_col', sortable: true, accessor: 'refunded_col' },
        { name: 'Composté', string: 'validated_col', sortable: true, accessor: 'validated_col' },
        { name: 'Composté le', string: 'date_validated_col', sortable: true, accessor: 'date_col' },
        { name: 'Actions', width: 250, accessor: 'actions', hasButton: true, cell: (item) => (
            <div>
              <ConfirmButton
                title={!item.validated ? 'Valider' : 'Invalider'}
                confirmTitle={'Êtes-vous sûr de vouloir ' + (item.validated ? 'invalider' : 'valider') + ' ce ticket ?'}
                onPress={(e) => {
                  e.stopPropagation();
                  onValidate(item, !item.validated)
                }} />
              {!item.validated && !item.refunded && item.price > 0 &&
                <>
                  <span> </span>
                  <ConfirmButton
                    title={'Rembourser'}
                    confirmTitle={'Êtes-vous sûr de vouloir rembourser ce ticket ?'}
                    onPress={(e) => {
                      e.stopPropagation();
                      onRefund(item)
                    }} />
                </>
              }
            </div>
          )},
      ]}
      />
  )
}

interface Props {
  element: any;
}
const TicketingOrders: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const elementId = props.element.id
  const elementRef = Fire.collection('ads').doc(elementId)
  const type = props.element.type
  const user = useSelector(state => state.authReducer.user)

  const onFetch = async () => {
    try {
      let ordersRef: any = Fire.collection('orders').where('element.id', '==', elementId)
      if (!user.admin) {
        ordersRef = ordersRef.where('proId', '==', user.id)
      }
      ordersRef = ordersRef.orderBy('createdAt', 'desc')
      const list = await Fire.list(ordersRef)
      for (const item of list) {
        item.pops_col = item.used_pops || 0
        item.tickets_count_col = item.tickets ? item.tickets.length : 0
        item.name_col = item.user ? (item.user.first_name + ' ' + item.user.last_name) : '-'
        item.email_col = item.user ? item.user.email : '-'
        item.total_col = Tools.renderPrice(item.total)
        item.invoice_col = item.invoice_link || '-'
        item.date_created_col = item.createdAt ? Fire.getDateFor(item.createdAt) : new Date()
        item.date_col = item.createdAt ? Time.moment(Fire.getDateFor(item.createdAt)).format('DD/MM/YYYY HH[h]mm') : '-'
      }
      return list
    } catch (err) {
      setError("Impossible de charger les commandes")
      console.warn(err)
    }
    return []
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name_col) || Tools.matchesSearch(search, item.ref) || Tools.matchesSearch(search, item.email_col))
  }

  return (
    <ListContainer
      title="Participants"
      searchTitle="Rechercher un participant..."
      error={error}
      onFetch={onFetch}
      onSelect={(item) => void 0}
      sorting={sorting}
      renderColumns={({ refresh }) => ([
        { name: 'N° Commande', string: 'ref', sortable: true, accessor: 'ref' },
        { name: 'Nom', string: 'name_col', sortable: true, accessor: 'name_col' },
        { name: 'Email', string: 'email_col', sortable: true, accessor: 'email_col' },
        { name: 'Total', sortable: true, accessor: 'total_col' },
        { name: 'Nb billets', sortable: true, accessor: 'tickets_count_col' },
        { name: 'Pops utilisés', sortable: true, accessor: 'pops_col' },
        { name: 'Facture', sortable: true, accessor: 'invoice_col', cell: (item) => item.invoice_link ? (
          <a target="_blank" href={item.invoice_link}>Voir la facture</a>
        ) : ('-')},
        { name: 'Créé le', date: 'date_created_col', sortable: true, accessor: 'date_col' },
      ])}
      expandableRow={(item: any, refresh) => (
        <ExpandedComponent data={item} refresh={refresh} />
      )}
      />
  );
}

export default TicketingOrders
